import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "operator", "results"]

  connect() {
    this.cachedPhoneNumber = null
    this.cachedValue = this.operatorTarget.value
  }

  search() {
    const phoneNumber = this.inputTarget.value

    if (this.cachedPhoneNumber === phoneNumber) return

    const resultsTarget = this.resultsTarget
    const operatorId = this.operatorTarget
    resultsTarget.innerHTML = "No user found"
    operatorId.value = this.cachedValue || ""
    this.cachedPhoneNumber = null

    if (phoneNumber.length !== 17) return

    const url = this.element.dataset.userLookupUrl
    this.cachedPhoneNumber = phoneNumber

    fetch(`${url}?phone_number=${encodeURIComponent(phoneNumber)}`)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok")
        return response.json()
      })
      .then((data) => {
        if (data && data.name) {
          operatorId.value = data.id
          resultsTarget.innerHTML = data.name
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error)
      })
  }
}
